import { Link, LinkProps } from "react-router-dom";

type Props = LinkProps & { to: string }
const VersionSensitiveLink = ({ to, children, ...props }: Props) => {
  return <Link to={to} {...props}>{children}</Link>;
};

export default VersionSensitiveLink;